import React from 'react'
import Start from './Start'
import InProgress from './InProgress'
import Complete from './Complete'

interface ScormCardProps {
  Unit: any
  active?: boolean
  Path?: any
}

const ScormCard: React.FC<ScormCardProps> = ({ Unit }) => {
  const unit = Unit?.unit
  const packages = unit?.packages
  if (!packages?.length) return null
  const localizedPackage = packages.find((pkg: any) => pkg.published)
  if (!localizedPackage) return null
  const normalizedUnit = {
    ...unit,
    packages: [localizedPackage],
  }

  switch (localizedPackage.status) {
    case 'not_started':
      return <Start unit={normalizedUnit} />
    case 'in_progress':
      return <InProgress unit={normalizedUnit} />
    case 'complete':
      return <Complete unit={normalizedUnit} />
    default:
      return null
  }
}

export default ScormCard
